const CAMERA_SELECTOR_DATA_ATTR = 'data-camera-selector';
const CAMERA_SELECTOR_PANEL_DATA_ATTR = 'data-camera-selector-panel';
const CAMERA_SELECTOR_DATA_VALUE = 'true';

const cameraSelectorRootSelector = `[${CAMERA_SELECTOR_DATA_ATTR}="${CAMERA_SELECTOR_DATA_VALUE}"]`;

/** Multi-site: visible tab panel; single-site: panel scroll wrapper (no site tabs). */
const multiSitePanelSelector = `${cameraSelectorRootSelector} [role="tabpanel"]:not([data-hidden])`;
const singleSitePanelSelector = `${cameraSelectorRootSelector} [${CAMERA_SELECTOR_PANEL_DATA_ATTR}="${CAMERA_SELECTOR_DATA_VALUE}"]`;

export const cameraSelectCardSelector = '[data-camera-select-card="true"]';

/** Applies descendant to each panel branch (comma lists do not propagate a trailing descendant). */
const _panelDescendantSelector = (descendant: string) =>
  `${multiSitePanelSelector} ${descendant}, ${singleSitePanelSelector} ${descendant}`;

export const cameraSelectorTabsDataAttributes = {
  [CAMERA_SELECTOR_DATA_ATTR]: CAMERA_SELECTOR_DATA_VALUE,
};

/** Applied to the single-site panel scroll wrapper for gamepad card queries. */
export const cameraSelectorSingleSitePanelDataAttributes = {
  [CAMERA_SELECTOR_PANEL_DATA_ATTR]: CAMERA_SELECTOR_DATA_VALUE,
};

export const cameraSelectorSiteTabSelector = `${cameraSelectorRootSelector} [role="tab"]:not([aria-disabled="true"]):not([data-disabled])`;

export const cameraSelectorActiveSiteTabSelector = `${cameraSelectorSiteTabSelector}[aria-selected="true"], ${cameraSelectorSiteTabSelector}[data-selected]`;

export const activeSiteTabPanelCameraCardSelector =
  _panelDescendantSelector(cameraSelectCardSelector);

const getCameraSelectCardByIdSelector = (cameraId: string) =>
  `${cameraSelectCardSelector}[data-camera-select-id="${CSS.escape(cameraId)}"]`;

export const getActiveSiteTabPanelCameraSelectCardByIdSelector = (cameraId: string) =>
  _panelDescendantSelector(getCameraSelectCardByIdSelector(cameraId));
